import React from 'react';
import './Activity.css';
import {VerticalTimelineElement} from 'react-vertical-timeline-component';
import {Icon} from 'react-onsenui';
import TimeAgo from 'javascript-time-ago';

// TimeAgo.add(en);
import en from 'javascript-time-ago/locale/en';
TimeAgo.addLocale(en);
const timeAgo = new TimeAgo('en-US');


const SENDER_TYPES = {
    "USER": "USER",
    "BOT": "BOT",
    "AGENT": "AGENT"
}

const SENDER_PLATFORMS = {
    "WEBCHAT": "WEBCHAT",
    "EMAIL": "EMAIL",
    "TEXT_MESSAGE": "TEXT_MESSAGE"
}

// eslint-disable-next-line import/no-anonymous-default-export
export default ({activity}) => {
    const {senderPlatform, senderType} = activity;

    let bodyToRender = "";
    if (senderType === SENDER_TYPES.USER) {
        bodyToRender = activity.nlpLog.textForNlp;
    } else if (senderType === SENDER_TYPES.BOT) {
        if (senderPlatform === SENDER_PLATFORMS.WEBCHAT) {
            //TODO : need to go over all chat components and render them well
            bodyToRender = <div dangerouslySetInnerHTML={{__html: activity.message.text}}/>
        } else if (senderPlatform === SENDER_PLATFORMS.EMAIL) {
            bodyToRender = <div dangerouslySetInnerHTML={{__html: activity.message.threadTopMessageHtml}}/>
        } else if (senderPlatform === SENDER_PLATFORMS.TEXT_MESSAGE) {
            bodyToRender = <div dangerouslySetInnerHTML={{__html: activity.message.threadTopMessageHtml}}/>
        }
    }

    let iconName = ""
    if (senderPlatform === SENDER_PLATFORMS.EMAIL) {
        iconName = "envelope"
    } else if (senderPlatform === SENDER_PLATFORMS.TEXT_MESSAGE) {
        iconName = "sms"
    } else if (senderPlatform === SENDER_PLATFORMS.WEBCHAT) {
        iconName = "comment-alt"
    }

    return <VerticalTimelineElement
        className={`vertical-timeline-element--${senderType}`}
        // date="2010 - 2011"
        iconStyle={{
            background: senderType === SENDER_TYPES.BOT ? "#7265e6" : "#1890ff",
            color: '#fff',
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
        }}
        icon={<Icon
            size={24}
            icon={senderType === SENDER_TYPES.BOT ? ("headset") : ("user")}/>}
    >
        {/*<h3 className="vertical-timeline-element-title">Art Director</h3>*/}
        {/*<h4 className="vertical-timeline-element-subtitle">San Francisco, CA</h4>*/}
        <div className="activity_header">
            <div className="template_details">
                <div>
                    <Icon
                        style={{paddingRight: "0.5em"}}
                        size={12}
                        icon={iconName}/>
                    {
                        senderType === SENDER_TYPES.BOT && senderPlatform !== SENDER_PLATFORMS.WEBCHAT &&
                        <span style={{
                            textTransform: "uppercase",
                            fontWeight: "bold"
                        }}>{activity.message.templateType}</span>
                    }
                </div>

                {timeAgo.format(new Date(activity.message.sentTimeStamp))}
            </div>
            {activity.message.subject}
        </div>
        <p className="activity_content">
            {bodyToRender}
        </p>
    </VerticalTimelineElement>
}